import React from 'react'
import { SeoSection as SeoSectionTransport } from '../../../transports/home-page-transport'
import FAQTransport from '../../../transports/common/faq-transport'
import { Section, SeoList, SeoItem, Question } from './styles'
import { CustomMarkdown } from '../common/styles'

interface SeoSectionProps {
    seoQuestions?: SeoSectionTransport
}

const SeoSection: React.FC<SeoSectionProps> = ({ seoQuestions }) => {
    const questionAnswers = seoQuestions?.questionAnswers

    if (!questionAnswers?.length) {
        return null
    }

    return (
        <Section>
            <SeoList>
                {questionAnswers.map((qa: FAQTransport, index: number) => (
                    <SeoItem key={`seo-${index}`}>
                        <Question>{qa.question}</Question>
                        <CustomMarkdown>{qa.answer}</CustomMarkdown>
                    </SeoItem>
                ))}
            </SeoList>
        </Section>
    )
}

export default SeoSection
